import RequestIcon from '../../../icons/service-request.svg'

export const REQUEST_SEARCH_ITEM_ICON = { Icon: RequestIcon }
